import {
    actionCreator,
    checkHttpStatus,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
    BehaviourDataActionTypes,
    GET_PATIENT_RECORD_ABC_DATA_LIST_API,
    POST_PATIENT_RECORD_ABC_DATA_LIST_API,
    GET_PATIENT_RECORD_FREQUENCY_DATA_LIST_API,
    POST_PATIENT_RECORD_FREQUENCY_DATA_LIST_API,
    GET_PATIENT_RECORD_DURATION_DATA_LIST_API,
    GET_PATIENT_TODAYS_DURATION_DATA_LIST_API,
    DELETE_PATIENT_TODAYS_DURATION_DATA_LIST_API,
    GET_PATIENT_TODAYS_RECORD_ABC_DATA_LIST_API,
    DELETE_PATIENT_TODAYS_RECORD_ABC_DATA_API,
    GET_PATIENT_TODAYS_FREQUENCY_DATA_LIST_API,
    DELETE_PATIENT_TODAYS_FREQUENCY_DATA_LIST_API,
    POST_PATIENT_RECORD_DURATION_API,
    GET_PATIENT_RECORD_RATE_API,
    POST_PATIENT_RECORD_RATE_API,
    GET_PATIENT_TODAYS_RATE_DATA_LIST_API,
    DELETE_PATIENT_TODAYS_RATE_DATA_LIST_API,
    GET_PATIENT_RECORD_INTERVAL_API,
    GET_PATIENT_RECORD_INTERVAL_CUSTOM_TIME_API,
    POST_PATIENT_RECORD_INTERVAL_API,
    GET_PATIENT_TODAYS_INTERVAL_DATA_LIST_API,
    DELETE_PATIENT_TODAYS_INTERVAL_DATA_LIST_API,
    GET_PATIENT_RECORD_MOMENTARY_DATA_LIST_API,
    POST_PATIENT_RECORD_MOMENTARY_DATA_LIST_API,
    GET_PATIENT_TODAYS_RECORD_MOMENTARY_DATA_LIST_API,
    DELETE_PATIENT_TODAYS_RECORD_MOMENTARY_DATA_API,
    UPDATE_BEHAVIOR_COLLECT_DATA_API
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import {reset } from 'redux-form';

 import GlobalVariables from '../../../../../../../actions/utilAction';

export const PatientRecordABCDataList = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordABCData_List.REQUEST));
        fetch(`${GET_PATIENT_RECORD_ABC_DATA_LIST_API}?patientId=${patientId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordABCData_List.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordABCData_List.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientRecordABCData_List', error);
            });
    };
};

export const SavePatientRecordABCData = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordABCData.REQUEST));
        fetch(`${POST_PATIENT_RECORD_ABC_DATA_LIST_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordABCData.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordABCData.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_patientRecordABCData', error);
            });
    };
};

export const PatientRecordRecordFrequencyList = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordFrequencyData.REQUEST));
        fetch(`${GET_PATIENT_RECORD_FREQUENCY_DATA_LIST_API}?patientId=${patientId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordFrequencyData.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordFrequencyData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientRecordFrequencyData', error);
            });
    };
};

export const SavePatientRecordFrequencyData = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordFrequencyData.REQUEST));
        fetch(`${POST_PATIENT_RECORD_FREQUENCY_DATA_LIST_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordFrequencyData.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordFrequencyData.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_patientRecordFrequencyData', error);
            });
    };
};

export const PatientRecordDurationDataList = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordDurationData.REQUEST));
        fetch(`${GET_PATIENT_RECORD_DURATION_DATA_LIST_API}?patientId=${patientId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordDurationData.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordDurationData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientRecordDurationData', error);
            });
    };
};


export const PatientTodaysRecordABCDataListAction = (patientId, sessionId, sessionDate) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRecordABCDataList.REQUEST));
        fetch(`${GET_PATIENT_TODAYS_RECORD_ABC_DATA_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRecordABCDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRecordABCDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientTodaysRecordABCDataList', error);
            });
    };
};

export const deletePatientTodaysRecordABCDataAction = (recordABCDataId, patientId, sessionId, sessionDate) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordABCDataList.REQUEST));
        fetch(`${DELETE_PATIENT_TODAYS_RECORD_ABC_DATA_API}?recordABCDataId=${recordABCDataId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordABCDataList.SUCCESS, response));
                    dispatch(PatientTodaysRecordABCDataListAction(patientId, sessionId, sessionDate));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordABCDataList.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordABCDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_patientTodaysRecordABCDataList', error);
            });
    };
};


export const PatientTodaysRecordFrequencyDataListAction = (patientId, sessionId, sessionDate) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysFrequencyDataList.REQUEST));
        fetch(`${GET_PATIENT_TODAYS_FREQUENCY_DATA_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysFrequencyDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysFrequencyDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientTodaysFrequencyDataList', error);
            });
    };
};


export const deletePatientTodaysRecordFrequencyDataAction = (recordFrequencyDataId, patientId, sessionId, sessionDate) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysFrequencyDataList.REQUEST));
        fetch(`${DELETE_PATIENT_TODAYS_FREQUENCY_DATA_LIST_API}?recordFrequencyDataId=${recordFrequencyDataId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysFrequencyDataList.SUCCESS, response));
                    dispatch(PatientTodaysRecordFrequencyDataListAction(patientId, sessionId, sessionDate));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysFrequencyDataList.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysFrequencyDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_patientTodaysFrequencyDataList', error);
            });
    };
};


/* For stopwatch only  starts*/

export const isRecordDurationRenderTrue = (flag) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.set_isRecordDurationRenderTrue.SUCCESS, flag));
    }
}

export const isRecordDurationStart = (index, flag) => { 
    return (dispatch, getState) => {
        let isStartDurationdata = getState().patientRecordDurationCustomReducer.isStart
        isStartDurationdata[index] = flag;
        dispatch(actionCreator(BehaviourDataActionTypes.start_recordDurationTimer.SUCCESS, isStartDurationdata));
    }
}

/////////////////////
const paustInterval = (incrementer) =>{
    if(incrementer){
        incrementer.forEach(i=>{
            if(i){
            //   console.log("print-- i",i)
              clearInterval(i);
            }
          })
    }
}
////////////////


const MAX_HOURS = 1000 * 60 * 60 * 8; 

// const MAX_HOURS = 1000 * 60 *  5; 
//const MAX_HOURS = 1000 * 30; 


export const customSecondsElapsed = (type, index) => {
    if(type === "mount") {
        // console.log('inside mount');
        return (dispatch, getState) => {
            let incrementer = getState().patientRecordDurationCustomReducer.incrementer;
            let secondElapsedA = getState().patientRecordDurationCustomReducer.secondsElapsed;

            if( secondElapsedA[index]>=MAX_HOURS){
                clearInterval(incrementer[index]);
                let secondsElapsed = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                let isStart = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                secondsElapsed[index] = 0;
                isStart[index] = 0;

                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedReset.SUCCESS,{secondsElapsed,isStart}))
            }

            incrementer[index] = setInterval(() => {
                let secondsElapsed = getState().patientRecordDurationCustomReducer.secondsElapsed;
                secondsElapsed[index] = secondsElapsed[index] + 1
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsed.SUCCESS, secondsElapsed))
            }, 1000)

            setTimeout(()=>{
                clearInterval(incrementer[index]);
                let secondsElapsed = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                let isStart = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                secondsElapsed[index] = 0;
                isStart[index] = 0;

                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedReset.SUCCESS,{secondsElapsed,isStart}))
            },MAX_HOURS)


            // if(getState().login && getState().login.loginUserInfo && getState().login.loginUserInfo.userID){
            //     let prevUserId = localStorage.getItem('prevUserId');
            //     let userId = getState().login.loginUserInfo.userID;
            //     console.log("case userId", userId);
            //     console.log("case prevUserId", prevUserId);
            //     if( prevUserId && userId ){
            //         if( prevUserId !== userId ){
            //             console.log("if case");
            //             clearInterval(incrementer[index]);
            //             localStorage.removeItem('prevUserId');
            //             dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedReset.SUCCESS,{secondsElapsed:[],isStart:[]}))
            //         }else{
            //             console.log("else case");
            //             localStorage.removeItem('prevUserId');
            //         }
            //     }else{
            //         console.log("outer else case");
            //         localStorage.removeItem('prevUserId');
            //     }
            // }

            // if(!getState().login.access_token){
            //     paustInterval(incrementer);
            // }
        }
    } else if (type === "unmount") {
        // console.log('inside unmount');
        return (dispatch, getState) => {
            let newIncrementer = getState().patientRecordDurationCustomReducer.newIncrementer;
            let secondElapsedA = getState().patientRecordDurationCustomReducer.secondsElapsed;
            if( secondElapsedA[index]>=MAX_HOURS){
                clearInterval(newIncrementer[index]);
                let secondsElapsed = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                let isStart = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                secondsElapsed[index] = 0;
                isStart[index] = 0;

                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedReset.SUCCESS,{secondsElapsed,isStart}))
            }
            
            newIncrementer[index] = setInterval(() => {
                let secondsElapsed = getState().patientRecordDurationCustomReducer.secondsElapsed
                secondsElapsed[index] = secondsElapsed[index] + 1
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsed.SUCCESS, secondsElapsed))
            }, 1000);

            setTimeout(()=>{
                clearInterval(newIncrementer[index]);
                let secondsElapsed = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                let isStart = [...getState().patientRecordDurationCustomReducer.secondsElapsed];
                secondsElapsed[index] = 0;
                isStart[index] = 0;

                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedReset.SUCCESS,{secondsElapsed,isStart}))
            },MAX_HOURS-secondElapsedA[index])


            // if(getState().login && getState().login.loginUserInfo && getState().login.loginUserInfo.userID){
            //     let prevUserId = localStorage.getItem('prevUserId');
            //     let userId = getState().login.loginUserInfo.userID;
            //     console.log("case userId", userId);
            //     console.log("case prevUserId", prevUserId);
            //     if( prevUserId && userId ){
            //         if( prevUserId !== userId ){
            //             console.log("if case");
            //             clearInterval(newIncrementer[index]);
            //             localStorage.removeItem('prevUserId');
            //             dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedReset.SUCCESS,{secondsElapsed:[],isStart:[]}))
            //         }else{
            //             console.log("else case");
            //             localStorage.removeItem('prevUserId');
            //         }
            //     }else{
            //         console.log("outer else case");
            //         localStorage.removeItem('prevUserId');
            //     }
            // }

            // if(!getState().login.access_token){
            //     paustInterval(newIncrementer);
            // }
        }
    }
}

/* For stopwatch only  ends */

export const SavePatientRecordDurationData = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.post_patinetRecordDurationData.REQUEST));
        fetch(`${POST_PATIENT_RECORD_DURATION_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.post_patinetRecordDurationData.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.post_patinetRecordDurationData.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error post_patinetRecordDurationData', error);
            });
    };
};

export const PatientTodaysRecordDurationDataListAction = (patientId, sessionId, sessionDate) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysDurationDataList.REQUEST));
        fetch(`${GET_PATIENT_TODAYS_DURATION_DATA_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysDurationDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysDurationDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientTodaysDurationDataList', error);
            });
    };
};

export const deletePatientTodaysRecordDurationDataAction = (recordDurationDataId, patientId, sessionId, sessionDate) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysDurationDataList.REQUEST));
        fetch(`${DELETE_PATIENT_TODAYS_DURATION_DATA_LIST_API}?recordDurationDataId=${recordDurationDataId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysDurationDataList.SUCCESS, response));
                    dispatch(PatientTodaysRecordDurationDataListAction(patientId, sessionId, sessionDate));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysDurationDataList.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysDurationDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_patientTodaysDurationDataList', error);
            });
    };
};


/* For Record Rate starts */

export const PatientRecordRateAction = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordRateData.REQUEST));
        fetch(`${GET_PATIENT_RECORD_RATE_API}?patientId=${patientId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordRateData.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordRateData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientRecordRateData', error);
            });
    };
};

export const isRecordRateStart = (flag) => {  
    return (dispatch, getState) => {
        let isStartDurationdata = getState().patientRecordDurationCustomReducer.isStart
        isStartDurationdata = flag;
        dispatch(actionCreator(BehaviourDataActionTypes.start_recordRateTimer.SUCCESS, isStartDurationdata));
    }
}

export const customSecondsElapsedForRate = (type) => {
    if(type === "mount") {
        return (dispatch, getState) => {
            let incrementer = getState().patientRecordRateCustomReducer.incrementer;
            incrementer[0] = setInterval(() => {
                let secondsElapsed = getState().patientRecordRateCustomReducer.secondsElapsed
                secondsElapsed = secondsElapsed + 1
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForRate.SUCCESS, secondsElapsed))
            }, 1000)
        }
    } else if(type === "unmount") {
        return (dispatch, getState) => {
            let newIncrementer = getState().patientRecordRateCustomReducer.newIncrementer;
            newIncrementer[0] = setInterval(() => {
                let secondsElapsed = getState().patientRecordRateCustomReducer.secondsElapsed
                secondsElapsed = secondsElapsed + 1
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForRate.SUCCESS, secondsElapsed))
            }, 1000)
        }
    }
}


export const resetRateTimer = () => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.reset_secondsElapsedForRate.SUCCESS, 0));
    }
}

export const SavePatientRecordRateData = (formProps,otherObj) => {
    let patientId = otherObj.patientId;
    let createdDate = otherObj.createdDate;
    let uuid = otherObj.uuid

    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordRateData.REQUEST));
        fetch(`${POST_PATIENT_RECORD_RATE_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(
                        PatientTodaysRecordRateDataListAction(patientId, uuid,createdDate)
                    );
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordRateData.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(
                        PatientTodaysRecordRateDataListAction(patientId, uuid,createdDate)
                    );
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordRateData.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_patientRecordRateData', error);
            });
    };
};

export const PatientTodaysRecordRateDataListAction = (patientId, sessionId, sessionDate) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRateDataList.REQUEST));
        fetch(`${GET_PATIENT_TODAYS_RATE_DATA_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRateDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRateDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientTodaysRateDataList', error);
            });
    };
};

export const deletePatientTodaysRecordRateDataAction = (recordRateDataId, patientId, sessionId, sessionDate) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRateDataList.REQUEST));
        fetch(`${DELETE_PATIENT_TODAYS_RATE_DATA_LIST_API}?recordRateDataId=${recordRateDataId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRateDataList.SUCCESS, response));
                    dispatch(PatientTodaysRecordRateDataListAction(patientId, sessionId, sessionDate));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRateDataList.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRateDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_patientTodaysRateDataList', error);
            });
    };
};

export const rateValueStaticArrayAction = (type, index) => {
    if(type === "Minus") {
        return (dispatch, getState) => {
            let customRateArray = getState().patientRecordRateCustomReducer.customRateArray;
            if (customRateArray[index] > 0) {
                customRateArray[index] = customRateArray[index];
            } else {
                customRateArray[index] = 0;
            }
            customRateArray[index] =  customRateArray[index] - 1;
            dispatch(actionCreator(BehaviourDataActionTypes.set_customRateArray.SUCCESS, customRateArray));
        }
    } else if (type === "Plus") {
        return (dispatch, getState) => {
            let customRateArray = getState().patientRecordRateCustomReducer.customRateArray;
            if (customRateArray[index] > 0) {
                customRateArray[index] = customRateArray[index];
            } else {
                customRateArray[index] = 0;
            }
            customRateArray[index] =  customRateArray[index] + 1;
            dispatch(actionCreator(BehaviourDataActionTypes.set_customRateArray.SUCCESS, customRateArray));
        }
    }
}

export const resetCustomRateArray = () => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.reset_customRateArray.SUCCESS, []));
    }
}

/* For Record Rate starts */

/* For Record Interval starts */

export const PatientRecordIntervalAction = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordIntervalData.REQUEST));
        fetch(`${GET_PATIENT_RECORD_INTERVAL_API}?patientId=${patientId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordIntervalData.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordIntervalData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientRecordIntervalData', error);
            });
    };
};

export const PatientRecordIntervalCustomeTimeAction = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordIntervalCustomTimeData.REQUEST));
        fetch(`${GET_PATIENT_RECORD_INTERVAL_CUSTOM_TIME_API}?patientId=${patientId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.set_secondsElapsedForIntervalObservationCustom.SUCCESS, response.data.partialIntervalDuration * 60 ));
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordIntervalCustomTimeData.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordIntervalCustomTimeData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientRecordIntervalCustomTimeData', error);
            });
    };
};

export const isRecordIntervalStart = (flag) => { 
    return (dispatch, getState) => {
        let isStartIntervaldata = getState().patientRecordDurationCustomReducer.isStart
        isStartIntervaldata = flag;
        dispatch(actionCreator(BehaviourDataActionTypes.start_recordIntervalTimer.SUCCESS, isStartIntervaldata));
    }
}

export const customSecondsElapsedForInterval = (type) => {
    if(type === "mount") {
        return (dispatch, getState) => {
            let intervalCount = getState().patientRecordIntervalCustomReducer.intervalCount;
            let customIntervalTime = getState().patientRecordIntervalCustomReducer.recordIntervalCustomTime && getState().patientRecordIntervalCustomReducer.recordIntervalCustomTime.data ? getState().patientRecordIntervalCustomReducer.recordIntervalCustomTime.data.partialIntervalDuration : GlobalVariables.IntervalDuration;
            customIntervalTime  = Math.floor(customIntervalTime * 60);
            let incrementer = getState().patientRecordIntervalCustomReducer.incrementer;
            incrementer[0] = setInterval(() => {
                let secondsElapsed = getState().patientRecordIntervalCustomReducer.secondsElapsed
                secondsElapsed = secondsElapsed + 1
                if(secondsElapsed === (intervalCount * customIntervalTime)) {
                    intervalCount = intervalCount + 1
                    dispatch(actionCreator(BehaviourDataActionTypes.set_intervalCount.SUCCESS, intervalCount))
                }
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForInterval.SUCCESS, secondsElapsed))
            }, 1000)
        }
    } else if (type === "unmount") {
        return (dispatch, getState) => {
            let intervalCount = getState().patientRecordIntervalCustomReducer.intervalCount;
            let customIntervalTime = getState().patientRecordIntervalCustomReducer.recordIntervalCustomTime && getState().patientRecordIntervalCustomReducer.recordIntervalCustomTime.data ? getState().patientRecordIntervalCustomReducer.recordIntervalCustomTime.data.partialIntervalDuration : GlobalVariables.IntervalDuration;
            customIntervalTime  = customIntervalTime * 60
            let newIncrementer = getState().patientRecordIntervalCustomReducer.newIncrementer;
            newIncrementer[0] = setInterval(() => {
                let secondsElapsed = getState().patientRecordIntervalCustomReducer.secondsElapsed
                secondsElapsed = secondsElapsed + 1
                if(secondsElapsed === (intervalCount * customIntervalTime)) {
                    intervalCount = intervalCount + 1
                    dispatch(actionCreator(BehaviourDataActionTypes.set_intervalCount.SUCCESS, intervalCount))
                }
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForInterval.SUCCESS, secondsElapsed))
            }, 1000)
        }
    }
}

export const customSecondsElapsedForIntervalObservation = (type) => {
    if(type === "mount") {
        return (dispatch, getState) => {
            let observationIntervalIncrementerOne = getState().patientRecordIntervalCustomReducer.observationIntervalIncrementerOne;
            observationIntervalIncrementerOne[0] = setInterval(() => {
                let observationIntervalSecondsElapsed = getState().patientRecordIntervalCustomReducer.observationIntervalSecondsElapsed;
                if(observationIntervalSecondsElapsed > 1) {
                    observationIntervalSecondsElapsed = observationIntervalSecondsElapsed - 1
                    dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForIntervalObservation.SUCCESS, observationIntervalSecondsElapsed))
                }
                else if(Math.ceil(observationIntervalSecondsElapsed) === 1) {
                    let observationIntervalSecondsElapsed = getState().patientRecordIntervalCustomReducer.observationIntervalSecondsElapsedCustom;                    
                    dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForIntervalObservation.SUCCESS, observationIntervalSecondsElapsed))
                }
                
            }, 1000)
        }
    } else if(type === "unmount") {
        return (dispatch, getState) => {          
            let observationIntervalIncrementerTwo = getState().patientRecordIntervalCustomReducer.observationIntervalIncrementerTwo;
            observationIntervalIncrementerTwo[0] = setInterval(() => {
                let observationIntervalSecondsElapsed = getState().patientRecordIntervalCustomReducer.observationIntervalSecondsElapsed
                if(observationIntervalSecondsElapsed > 0) {
                    observationIntervalSecondsElapsed = observationIntervalSecondsElapsed - 1
                    dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForIntervalObservation.SUCCESS, observationIntervalSecondsElapsed))
                }
                else if(observationIntervalSecondsElapsed === 0) {
                    let observationIntervalSecondsElapsed = getState().patientRecordIntervalCustomReducer.observationIntervalSecondsElapsedCustom;                    
                    dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForIntervalObservation.SUCCESS, observationIntervalSecondsElapsed))
                }
            }, 1000)
        }
    }
}

export const ReversecustomSecondsElapsedForInterval = () => {
    return (dispatch, getState) => {
        let incrementerForReverse = getState().patientRecordIntervalCustomReducer.incrementerForReverse;
        
        incrementerForReverse[0] = setInterval(() => {
            let reverseSecondsElapsed = getState().patientRecordIntervalCustomReducer.reverseCounter;
            let intervalCount = getState().patientRecordIntervalCustomReducer.intervalCount;
            if (reverseSecondsElapsed > 0) {
                reverseSecondsElapsed = reverseSecondsElapsed - 1
                dispatch(actionCreator(BehaviourDataActionTypes.start_ReverseSecondsElapsedForInterval.SUCCESS, reverseSecondsElapsed))
            } else if(reverseSecondsElapsed === 0) {
                if(reverseSecondsElapsed === 0) {
                    intervalCount = intervalCount + 1
                    dispatch(actionCreator(BehaviourDataActionTypes.set_intervalCount.SUCCESS, intervalCount))
                }               
                reverseSecondsElapsed = reverseSecondsElapsed - 1;
                dispatch(actionCreator(BehaviourDataActionTypes.start_ReverseSecondsElapsedForInterval.SUCCESS, reverseSecondsElapsed))
            }
        }, 1000)
    }
}

export const resetIntervalTimer = () => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.reset_secondsElapsedForInterval.SUCCESS, 0));
    }
}

export const resetIntervalObservationTimer = () => {
    return (dispatch,getState) => {
        let value = getState().patientRecordIntervalCustomReducer.observationIntervalSecondsElapsedCustom;
        dispatch(actionCreator(BehaviourDataActionTypes.reset_secondsElapsedForIntervalObservation.SUCCESS, value));
    }
}

export const resetReverseIntervalTimer = () => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.reset_reverseSecondsElapsedForInterval.SUCCESS, 0));
    }
}

export const resetIntervalCount = () => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.reset_IntervalCount.SUCCESS, 1));
    }
}

export const SavePatientRecordIntervalData = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordIntervalData.REQUEST));
        fetch(`${POST_PATIENT_RECORD_INTERVAL_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(reset("RecordIntervalForm"));
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordIntervalData.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordIntervalData.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_patientRecordIntervalData', error);
            });
    };
};

export const PatientTodaysRecordIntervalDataListAction = (patientId, sessionId, sessionDate) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysIntervalDataList.REQUEST));
        fetch(`${GET_PATIENT_TODAYS_INTERVAL_DATA_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysIntervalDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysIntervalDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientTodaysIntervalDataList', error);
            });
    };
};


export const deletePatientTodaysRecordIntervalDataAction = (recordPartialIntervalDataId, patientId, sessionId, sessionDate) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysIntervalDataList.REQUEST));
        fetch(`${DELETE_PATIENT_TODAYS_INTERVAL_DATA_LIST_API}?recordPartialIntervalDataId=${recordPartialIntervalDataId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysIntervalDataList.SUCCESS, response));
                    dispatch(PatientTodaysRecordIntervalDataListAction(patientId, sessionId, sessionDate));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysIntervalDataList.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysIntervalDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_patientTodaysIntervalDataList', error);
            });
    };
};

   
export const IntervalValueStaticArrayAction = (event, index, data) => {
        return (dispatch, getState) => {
            let selectedInterval = getState().patientRecordIntervalCustomReducer.customSelectedInterval;
            let isIntervalChecked = event.target.checked;
            if (isIntervalChecked) {
                selectedInterval.push(data.id);
                dispatch(actionCreator(BehaviourDataActionTypes.set_customSelectedInterval.SUCCESS, selectedInterval));

            } else {
                index = selectedInterval.findIndex((value) => value === data.id);
                if (index >= 0) {
                    selectedInterval.splice(index, 1);
                    dispatch(actionCreator(BehaviourDataActionTypes.set_customSelectedInterval.SUCCESS, selectedInterval));
                }
            }
        }
}

export const resetCustomIntervalArray = () => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.reset_customIntervalArray.SUCCESS, []));
    }
}

/* For Record Rate ends */

/* Record Momentary starts */

export const PatientRecordMoemtaryDataListAction = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordMomentaryData_List.REQUEST));
        fetch(`${GET_PATIENT_RECORD_MOMENTARY_DATA_LIST_API}?patientId=${patientId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordMomentaryData_List.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordMomentaryData_List.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientRecordMomentaryData_List', error);
            });
    };
};

export const SavePatientRecordMomentaryDataAction = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordMomentaryData.REQUEST));
        fetch(`${POST_PATIENT_RECORD_MOMENTARY_DATA_LIST_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordMomentaryData.SUCCESS, response));
                    dispatch(reset('RecordMomentaryForm'))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.save_patientRecordMomentaryData.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_patientRecordMomentaryData', error);
            });
    };
};

export const PatientTodaysRecordMomentaryDataListAction = (patientId, sessionId, sessionDate) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRecordMomentaryDataList.REQUEST));
        fetch(`${GET_PATIENT_TODAYS_RECORD_MOMENTARY_DATA_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRecordMomentaryDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(BehaviourDataActionTypes.get_patientTodaysRecordMomentaryDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientTodaysRecordMomentaryDataList', error);
            });
    };
};

export const deletePatientTodaysRecordMomentaryDataAction = (recordMomentaryDataId, patientId, sessionId, sessionDate) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordMomentaryDataList.REQUEST));
        fetch(`${DELETE_PATIENT_TODAYS_RECORD_MOMENTARY_DATA_API}?recordMomentaryDataId=${recordMomentaryDataId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordMomentaryDataList.SUCCESS, response));
                    dispatch(PatientTodaysRecordMomentaryDataListAction(patientId, sessionId, sessionDate));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordMomentaryDataList.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(BehaviourDataActionTypes.delete_patientTodaysRecordMomentaryDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_patientTodaysRecordMomentaryDataList', error);
            });
    };
};

export const isRecordMomentaryStart = (isStart,isSave) => { 
    return (dispatch, getState) => {
        let isStartMomentarydata = getState().patientRecordMomentaryCustomReducer.isStart
        isStartMomentarydata = {isStart,isSave};
        dispatch(actionCreator(BehaviourDataActionTypes.start_recordMomentaryTimer.SUCCESS, isStartMomentarydata));
    }
}

export const customSecondsElapsedForMomentary = (type) => {
    if(type === "mount") {
        return (dispatch, getState) => {
            let intervalCount = getState().patientRecordMomentaryCustomReducer.intervalCount;
            let customMomentaryTime = getState().patientRecordMomentaryCustomReducer.recordMomentaryCustomTime && getState().patientRecordMomentaryCustomReducer.recordMomentaryCustomTime.data ? getState().patientRecordMomentaryCustomReducer.recordMomentaryCustomTime.data.momentaryIntervalDuration : GlobalVariables.IntervalDuration;
            customMomentaryTime = customMomentaryTime * 60
            let incrementer = getState().patientRecordMomentaryCustomReducer.incrementer;
            incrementer[0] = setInterval(() => {
                let secondsElapsed = getState().patientRecordMomentaryCustomReducer.secondsElapsed
                secondsElapsed = secondsElapsed + 1
                if (secondsElapsed === (intervalCount *  Math.floor(customMomentaryTime))) {
                    intervalCount = intervalCount + 1
                    dispatch(actionCreator(BehaviourDataActionTypes.set_MomentaryIntervalCount.SUCCESS, intervalCount))
                }
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForMomentary.SUCCESS, secondsElapsed))
            }, 1000)
        }
    } else if(type === "unmount") {
        return (dispatch, getState) => {
            let intervalCount = getState().patientRecordMomentaryCustomReducer.intervalCount;
            let customMomentaryTime = getState().patientRecordMomentaryCustomReducer.recordMomentaryCustomTime && getState().patientRecordMomentaryCustomReducer.recordMomentaryCustomTime.data ? getState().patientRecordMomentaryCustomReducer.recordMomentaryCustomTime.data.momentaryIntervalDuration : GlobalVariables.IntervalDuration;
            customMomentaryTime = customMomentaryTime * 60
            let newIncrementer = getState().patientRecordMomentaryCustomReducer.newIncrementer;
            newIncrementer[0] = setInterval(() => {
                let secondsElapsed = getState().patientRecordMomentaryCustomReducer.secondsElapsed
                secondsElapsed = secondsElapsed + 1
                if (secondsElapsed === (intervalCount *  Math.floor(customMomentaryTime))) {
                    intervalCount = intervalCount + 1
                    dispatch(actionCreator(BehaviourDataActionTypes.set_MomentaryIntervalCount.SUCCESS, intervalCount))
                }
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForMomentary.SUCCESS, secondsElapsed))
            }, 1000)
        }
    }
}

export const customSecondsElapsedForMomentaryObservation = (type) => {
    if(type === "mount") {
        return (dispatch, getState) => {
            let observationIncrementerOne = getState().patientRecordMomentaryCustomReducer.observationIncrementerOne;
            observationIncrementerOne[0] = setInterval(() => {
                let observationSecondsElapsed = getState().patientRecordMomentaryCustomReducer.observationSecondsElapsed
                observationSecondsElapsed = observationSecondsElapsed + 1
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForMomentaryObservation.SUCCESS, observationSecondsElapsed))
            }, 1000)
        }
    } else if(type === "unmount") {
        return (dispatch, getState) => {          
            let observationIncrementerTwo = getState().patientRecordMomentaryCustomReducer.observationIncrementerTwo;
            observationIncrementerTwo[0] = setInterval(() => {
                let observationSecondsElapsed = getState().patientRecordMomentaryCustomReducer.observationSecondsElapsed
                observationSecondsElapsed = observationSecondsElapsed + 1
                dispatch(actionCreator(BehaviourDataActionTypes.start_secondsElapsedForMomentaryObservation.SUCCESS, observationSecondsElapsed))
            }, 1000)
        }
    }
}

    export const resetMomentaryTimer = () => {
        return (dispatch) => {
            dispatch(actionCreator(BehaviourDataActionTypes.reset_secondsElapsedForMomentary.SUCCESS, 0));
        }
    }

    export const resetMomentaryObservationTimer = () => {
        return (dispatch) => {
            dispatch(actionCreator(BehaviourDataActionTypes.reset_secondsElapsedForMomentaryObservation.SUCCESS, 0));
        }
    }
    
    export const resetMomentaryCount = () => {
        return (dispatch) => {
            dispatch(actionCreator(BehaviourDataActionTypes.reset_MomentaryIntervalCount.SUCCESS, 1));
        }
    }

    export const PatientRecordMomentaryCustomTimeAction = (patientId) => {
        return (dispatch, getState) => {
            dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordMomentaryCustomTimeData.REQUEST));
            fetch(`${GET_PATIENT_RECORD_INTERVAL_CUSTOM_TIME_API}?patientId=${patientId}`, {
                method: 'GET',
                headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            })
                .then(checkHttpStatus)
                .then(function (response) {
                    if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordMomentaryCustomTimeData.SUCCESS, response));
                    } else {
                        dispatch(actionCreator(BehaviourDataActionTypes.get_patientRecordMomentaryCustomTimeData.SUCCESS, null));
                    }
                }).catch(function (error) {
                    console.log('error get_patientRecordMomentaryCustomTimeData', error);
                });
        };
    };

    
export const moentaryValueStaticArrayAction = (type, index) => {
    if(type === "Minus") {
        return (dispatch, getState) => {
            let momentaryArray = getState().patientRecordMomentaryCustomReducer.customMomentaryArray;
            if (momentaryArray[index] > 0) {
                momentaryArray[index] = momentaryArray[index];
            } else {
                momentaryArray[index] = 0;
            }
            momentaryArray[index] =  momentaryArray[index] - 1;
            dispatch(actionCreator(BehaviourDataActionTypes.set_customMomentaryArray.SUCCESS, momentaryArray));
        }
    } else if (type === "Plus") {
        return (dispatch, getState) => {
            let momentaryArray = getState().patientRecordMomentaryCustomReducer.customMomentaryArray;
            if (momentaryArray[index] > 0) {
                momentaryArray[index] = momentaryArray[index];
            } else {
                momentaryArray[index] = 0;
            }
            momentaryArray[index] =  momentaryArray[index] + 1;
            dispatch(actionCreator(BehaviourDataActionTypes.set_customMomentaryArray.SUCCESS, momentaryArray));
        }
    }
}

export const resetCustomMomentaryArray = () => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.reset_customMomentaryArray.SUCCESS, []));
    }
}
//////////////
export const setBeepFlag = (flag) => {
    return (dispatch) => {
        dispatch(actionCreator(BehaviourDataActionTypes.set_beep_flag.SUCCESS,flag));
    }
}
////////////


export const UpdateCollectedBehaviorData = (collectedBehaviorDataId, recordDataDetailId, sessionDate, staffId, value, duration, patientId, action, recordingTypeName, sessionId, sessionDateForLoad) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(BehaviourDataActionTypes.update_collectedBehaviorDataStatus.REQUEST));
      fetch(`${UPDATE_BEHAVIOR_COLLECT_DATA_API}?collectedBehaviorDataId=${collectedBehaviorDataId}&recordDataDetailId=${recordDataDetailId}&sessionDate=${sessionDate}&staffId=${staffId}&value=${value}&duration=${duration}&patientId=${patientId}&actionName=${action}&recordingTypeName=${recordingTypeName}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);       
            if(recordingTypeName === 'FREQUENCY')
                dispatch(PatientTodaysRecordFrequencyDataListAction(patientId, sessionId, sessionDateForLoad));
            else if(recordingTypeName === 'DURATION')
                dispatch(PatientTodaysRecordDurationDataListAction(patientId, sessionId, sessionDateForLoad));
            else if(recordingTypeName === 'RATE')
                dispatch(PatientTodaysRecordRateDataListAction(patientId, sessionId, sessionDateForLoad));    
            else if(recordingTypeName === 'PARTIAL INTERVAL')
                dispatch(PatientTodaysRecordIntervalDataListAction(patientId, sessionId, sessionDateForLoad));    
            else if(recordingTypeName === 'MOMENTARY TIME SAMPLE')
                dispatch(PatientTodaysRecordMomentaryDataListAction(patientId, sessionId, sessionDateForLoad));
            else if(recordingTypeName==='ABCDATA')
                dispatch(PatientTodaysRecordMomentaryDataListAction(patientId, sessionId, sessionDateForLoad));    
                 
            dispatch(actionCreator(BehaviourDataActionTypes.update_collectedBehaviorDataStatus.SUCCESS, {}));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(BehaviourDataActionTypes.update_collectedBehaviorDataStatus.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(BehaviourDataActionTypes.update_collectedBehaviorDataStatus.SUCCESS, {}));
        });
    };
  };

/* Record Momentary Ends */



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/actions/BehaviourDataActions.js